import type { App } from 'vue';
import ElementPlus from 'element-plus';

import fr from 'element-plus/dist/locale/fr.mjs';

export default (app: App<Element>): void => {
    app.use(ElementPlus, { locale: fr });
};
